import { NOT_KNOWN } from 'customer-data-filters/converters/contactSearch/FilterContactSearchOperatorTypes';
import { TYPE } from 'customer-data-objects/task/TaskPropertyNames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import getIn from 'transmute/getIn';
import toJS from 'transmute/toJS';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import { TABLE_PROPERTIES } from '../../constants/properties';
import { OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT } from '../../constants/viewFilters';
import { useDispatch } from '../../context/Redux';
import { useTaskProperties } from '../../hooks/properties';
import { useTempFilters } from '../../hooks/useTempFilters';
import { updateTempViewCrmSearchQuery } from '../../redux/actions/tempViewState';
import { getTaskTypeFilter } from '../../utils/crmSearchFilters';
import { getPropertyFilter } from '../../utils/getPropertyFilterValue';
import QuickFilterContainer from './QuickFilterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const TYPE_OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT = [...OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT, NOT_KNOWN];
export function getTaskTypeValueFromFilters(crmSearchFilters) {
  const filterObject = getPropertyFilter(crmSearchFilters, TYPE);
  if (!filterObject || TYPE_OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT.includes(filterObject.operator)) {
    return [];
  }
  return filterObject.value ? [filterObject.value] : filterObject.values;
}
const TaskTypeFilter = ({
  viewId
}) => {
  const dispatch = useDispatch();
  const crmSearchFilters = useTempFilters(viewId);
  const {
    properties
  } = useTaskProperties(TABLE_PROPERTIES);
  const propertyDefinitionOptions = toJS(getIn([TYPE, 'options'], properties)) || [];
  const options = propertyDefinitionOptions.map(option => ({
    value: option.value,
    text: option.label
  }));
  const value = useMemo(() => getTaskTypeValueFromFilters(crmSearchFilters), [crmSearchFilters]);
  const filtersWithoutType = crmSearchFilters.filter(filter => filter.property !== TYPE);
  const handleChange = useCallback(event => {
    const newValue = event.target.value;
    const newFilters = newValue && newValue.length > 0 ? [...filtersWithoutType, getTaskTypeFilter(newValue)] : filtersWithoutType;
    dispatch(updateTempViewCrmSearchQuery({
      viewId,
      crmSearchFilters: newFilters
    }));
  }, [dispatch, filtersWithoutType, viewId]);
  const renderButtonContent = () => {
    return value && value.length > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.filters.taskType.labelWithNumSelected",
      options: {
        numSelected: value.length
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.filters.taskType.label"
    });
  };
  const shouldHighlightFilter = useMemo(() => {
    const filterObject = getPropertyFilter(crmSearchFilters, TYPE);
    const areTypesSelected = Array.isArray(value) && value.length > 0;
    // check if the filter is using an operator that shouldn't show any checks
    const isFilterApplied = filterObject && TYPE_OPERATORS_TO_NOT_SHOW_CHECKS_IN_SELECT.includes(filterObject.operator);
    return isFilterApplied || areTypesSelected;
  }, [crmSearchFilters, value]);
  return /*#__PURE__*/_jsx(QuickFilterContainer, {
    filterName: "task-type",
    onClear: () => handleChange(syntheticEvent([])),
    shouldHighlight: shouldHighlightFilter,
    shouldShowClearButton: shouldHighlightFilter,
    children: /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      ButtonContent: renderButtonContent,
      buttonUse: "transparent",
      clearable: true,
      "data-selenium-test": "task-type-quick-filter",
      "data-test-id": "task-type-quick-filter",
      menuWidth: "auto",
      multi: true,
      onChange: handleChange,
      options: options,
      searchable: false,
      value: value
    })
  });
};
export default TaskTypeFilter;